import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import vuetify from './plugins/vuetify'
import vueSmoothScroll from 'vue2-smooth-scroll'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faHandshake, faListAlt, faGlobeAmericas, faNewspaper, faAddressCard, faPhone, faEnvelope, faGlobe, faFileAlt, faUsers, faUserTie, faChalkboardTeacher, faMusic } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faHandshake, faListAlt, faGlobeAmericas, faNewspaper, faAddressCard, faPhone, faEnvelope, faGlobe, faFileAlt, faUsers, faUserTie, faChalkboardTeacher, faMusic)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(vueSmoothScroll)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
